import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NavLink } from 'react-router-dom';
import { iniciarMenu } from '../Helpers/Menu_helper.js';

const Menu = ({colapsState, colapsEvent}) => {
    const [state, setstate] = useState({});
    const [stateDataMenu, setStateDataMenu] = useState();

    useEffect(() => {
        const dataMenu = iniciarMenu();
        dataMenu.then(respuesta =>{
            setStateDataMenu(respuesta.data);
        })
    }, [])

    useEffect(() => {
        if(colapsState)
        {
            if(state !== undefined)
            {
                for(const propiedad in state)
                {
                    if(state[propiedad] === 'Activo')
                    {
                        const ulDropDown = document.getElementById(`${propiedad}`)
                        const ulDropDownIcon = document.getElementById(`${propiedad}-icon`)

                        ulDropDown.classList.remove('drop-down-menu-show')
                        ulDropDownIcon.classList.remove('drop-down-icon-animation')
                    }
                }
            }
        }
        else
        {
            if(state !== undefined)
            {
                for(const propiedad in state)
                {
                    if(state[propiedad] === 'Activo')
                    {
                        const ulDropDown = document.getElementById(`${propiedad}`)
                        const ulDropDownIcon = document.getElementById(`${propiedad}-icon`)

                        ulDropDown.classList.add('drop-down-menu-show')
                        ulDropDownIcon.classList.add('drop-down-icon-animation')
                    }
                }
            }
        }// eslint-disable-next-line
    }, [colapsState])

    const handleClickDropDownMenu = (id) =>{
        const ulDropDown = document.getElementById(`drop-down-menu-ul-${id}`);
        const ulDropDownIcon = document.getElementById(`drop-down-menu-ul-${id}-icon`);

        if(colapsState === true)
        {
            colapsEvent();
        }

        if(ulDropDown.classList.contains('drop-down-menu-show'))
        {
            setstate({
                ...state,
                [`drop-down-menu-ul-${id}`] : 'Inactivo'
            });

            ulDropDown.classList.remove('drop-down-menu-show')
            ulDropDownIcon.classList.remove('drop-down-icon-animation')
        }
        else
        {
            setstate({
                ...state,
                [`drop-down-menu-ul-${id}`] : 'Activo'
            });

            ulDropDown.classList.add('drop-down-menu-show')
            ulDropDownIcon.classList.add('drop-down-icon-animation')
        }
    };

    const handleClickUlHijo = (id) => {
        console.log(`handleClickUlHijo ${id}`);
    }

    return (
        <nav className="menuPrincipal">
                <ul>
                    {
                        (
                            stateDataMenu?.map((item, i) =>
                                (
                                    item.SUBMENU
                                    ?
                                    <li id={`li-padre-${i}`} key={item.CODMENU}>
                                        <div className="menu-item" onClick={() => handleClickDropDownMenu(i)}>
                                            <FontAwesomeIcon icon={['fad',`${item.ICONO}`]} className="icono-menu"/>
                                            <span>{item.DESCRIPMENU}</span>
                                            <FontAwesomeIcon icon={['fas','chevron-down']} className="drop-down-icon icon-fixed-width" id={`drop-down-menu-ul-${i}-icon`} />
                                        </div>
                                        <ul className="animate__animated animate__fadeInLeft animate__faster drop-down-menu" id={`drop-down-menu-ul-${i}`}>
                                            {
                                                (item.SUBMENU).map((submenu, x) =>
                                                    <li id={submenu.CODOPCION} key={submenu.CODOPCION}>
                                                        <NavLink exact to={submenu.PAGE} activeClassName={`activo-${i}`} onClick={() => handleClickUlHijo(i)}>
                                                            {submenu.DESCRIPOPCION}
                                                        </NavLink>
                                                    </li>
                                                )
                                            }
                                        </ul>
                                    </li>
                                    :
                                    <li id={`li-padre-${i}`} key={item.CODMENU}>
                                        <NavLink className="menu-item" exact to={item.PAGE} activeClassName={`activo-${i}`}>
                                            <FontAwesomeIcon icon={['fad',`${item.ICONO}`]} className="icono-menu"/>
                                            <span>{item.DESCRIPMENU}</span>
                                        </NavLink>
                                    </li>
                                )
                            )
                        )
                    }
                </ul>
        </nav>
    )
}

export default Menu
